import {HolidayDateUtils} from '../HolidayDateUtils'
import IconRobberCupid from '@static/images/icon_robber_cupid.svg'
import IconRobberSanta from '@static/images/icon_robber_santa.svg'
import IconRobber from '@static/images/icon_robber.svg'
import {ImageURL} from '@colonist/types'

class UIGameRobberSkinController {
    private readonly chosenSkin: ImageURL

    constructor() {
        const holiday = HolidayDateUtils.getCurrentHoliday()
        switch(holiday) {
            case 'valentines': {
                this.chosenSkin = IconRobberCupid
                break
            }
            case 'christmas': {
                this.chosenSkin = IconRobberSanta
                break
            }
            default:
                this.chosenSkin = IconRobber
                break
        }
    }

    getRobberSkin(): ImageURL {
        return this.chosenSkin
    }
}

export const robberSkinController = new UIGameRobberSkinController()
